export default __webpack_public_path__ + "static/media/scan.880b67c9.svg";